import createReactComponent from '../createReactComponent';
export default createReactComponent('outline', 'circle', 'IconCircle', [["path",{"d":"M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0","key":"svg-0"}]]);